import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'ORBRO quản lý hiệu quả sự di chuyển của cá nhân và phương tiện trong đô thị bằng cách tích hợp dữ liệu vị trí và trực quan hóa 3D. Để thực hiện điều này, ORBRO sử dụng các công nghệ và hệ thống đa dạng nhằm nâng cao tính an toàn và hiệu quả của hệ thống giao thông.',
  keywords: 'Bản sao số, RTLS, thành phố số, thực tế ảo, ban sao so, rtls, thanh pho so, thuc te ao.',
  ogSite: 'Digital Twin - Kết nối chuyển động thời gian thực của người và phương tiện',
  title: 'Digital Twin - Kết nối chuyển động thời gian thực của người và phương tiện',
  ogUrl: 'https://orbro.io/vi/blog/digitaltwin-tracking',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmsHKPo0k1JGpYe5RqcLPvhvPsttOE54okj7zmGDmBsNO7w1O-JK1oTjUeN0SXoXeuVHVRR0yqY597xyclhreNiwqO8zxMhslWsAccGNFJL7Cc4jphNGY1U-ApF8rYUJlkQ29hCvXhs1-kJ7ItJ8yzqul6tD2bkCeeSf24qL0tmKPNG7wJdcdkE8HnxTJ-dAJvm-HQ1tD8-RFPjUfTcllJI-RCb7dzd6jATNYzQbe1GQD7gejTG574T2T6jKa1sIQLT1me2evIreAszenpfb2ZOAOafbrlQEnfJCF577BDuUZxdtYW-PpTWZdcoK_GlrZTVEXWFVIe4zYY4BA9uI-4MvLCytQ19heux-zPZ2uj0Pd-eu04szV3P6TFIG2dqGtdzui7sXRbRh4-9toRM1UEYley9vu4sOHPbxuwV1LN97GHKbtKrmz4OsgOS0jK8VWR0v_KCwr08MXIduU_b2QT5axXUH4CSftoADRRfaDprmZIqjdAdy7RqILvmsg_V7NQAcd9xapuxx4MMoC42nj2n0iwd9yZV--15jzcgqW6daHUiYEZ4ggt7Uy2LoPScqjh7hhOm8vT1XPj6fSf3W1SgBduBXU9h5e0_bG9GKZLWMCy72SHi0Xs0NO0X7FSOgdDU0scaP-F8WlOsTezavpMEhxUlz2fhL_mBIfZVO25KKS-y-Qfuul0bpf2coLNtuVO4yW_hZEZuAzW7FbuIUdoyI04V7I493a1IXz6-A_ZcTH2j2retDHu_nD6RnBrnlcCsY0tnVCMM0ho0k_GLGaGTrs_88IPxii47Y_Qa1XXH-8-wwpGN0UocvGhXB6rdM7S-m7_MIT3ONC4MyvE3Bqjkid-QLeYtThJ2zXLCXfCIaCyi4jttco-MJjx84qBVRrUWpwcvpISJ7E9pYCJukWT1rgVNPsgO1baez2jR2IyH1hMZ4SXB6nHNVoylyuvAjn1uYfjDCfOgRlqmcK8wt3U1GImqc68KthjcbhAjDNmlLNtBl9Pd4Ksg0Xts8R_Z_LbV6Ue834BoCmu5H_jzmEevCkvwPsYoLsmqebwEqmrp2B58f2e32e0YY8L8jPuMPX3UDZyxX98adUK-gekxc1YB5JrqJPlcC4nZA-XLh8EmakSbt83hYYjIkhbHeafd7Hr5M-Em9znV_sFo2DaAwfkAQRoa80pNidI39UxDJVdey6nVP9H6UPL-i_N-H1K6LpiALIwQNKPMlI4up5e-hme40ZgUL9QKbBaKDyfOxk1aqml1cTzHCZJRP_jLw2dOoS1K-EG7OsGJDxmnclokA0StmKuFCPLAbAodPa1K_Btbk2GtITh4kvm07TLOp_LDZBnztDlzA8WuId3bEWiXNRc5qKlfv5UYlEn_k4L03K4A-T49R-Pi75Jp53wW68HhGwDoSbyYjaiI8plzJeyMyGJduXJZtYWh66ETIXdt8IxUDYw5otbzXD-lFsSLdM09U37NH_lU0c07Sjg77a4m1OfI1-mfJmHzqzvn9kksa3H2aYES0HhIq5RPgdd0NyW7b2IvL9b7nDE4tL4D-hf70biexJ_aaBkb=w1923-h1074',
  ogType: 'website',
  date: '2023-12-26',
  tag1: '#Bansaoso',
  tag2: '#Rtls',
  tag3: '#Thanhphoso',
  tag4: '#Thucteao',
  text: [
    {
      head: 'Digital Twin - Kết nối chuyển động thời gian thực của người và phương tiện',
      subHead: '',
      desc: 'ORBRO quản lý hiệu quả sự di chuyển của cá nhân và phương tiện trong đô thị bằng cách tích hợp dữ liệu vị trí và trực quan hóa 3D. Để thực hiện điều này, ORBRO sử dụng các công nghệ và hệ thống đa dạng nhằm nâng cao tính an toàn và hiệu quả của hệ thống giao thông.\nCông nghệ RTLS (Real-Time Location System - Hệ thống Định vị Thời gian Thực) theo dõi vị trí và chuyển động của con người theo thời gian thực, trong khi công nghệ hình ảnh giám sát chuyển động của phương tiện. Thông qua trực quan hóa 3D, các chuyển động động của người và phương tiện được biểu diễn một cách trực quan, và bằng cách chỉ định các khu vực (Zone), sự di chuyển trong các vùng cụ thể được quản lý một cách hiệu quả.\nBảng điều khiển chuyển đổi số tổng hợp dữ liệu thu thập được để cung cấp thông tin chuyên sâu, và việc tích hợp thành phố thông minh thúc đẩy tự động hóa và hiệu quả trong vận hành đô thị. Qua đó, tối ưu hóa luồng giao thông đô thị và việc sử dụng cơ sở hạ tầng, đồng thời hỗ trợ triển khai thành phố thông minh.',
      dot: '',
    },
    {
      head: 'Thu thập thông tin của người bằng công nghệ RTLS',
      subHead: '',
      desc: 'ORBRO sử dụng Hệ thống Định vị Thời gian Thực (RTLS) với độ chính xác cao để theo dõi vị trí và chuyển động của con người. Điều này đặc biệt quan trọng trong việc đảm bảo an toàn và an ninh cho mọi người tại các địa điểm công cộng quy mô lớn hoặc trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: 'Thu thập thông tin của phương tiện bằng công nghệ hình ảnh',
      subHead: '',
      desc: 'ORBRO sử dụng các công nghệ ghi hình đa dạng để giám sát và phân tích chuyển động của phương tiện trong đô thị theo thời gian thực. Điều này góp phần tối ưu hóa luồng giao thông và phòng ngừa tai nạn giao thông.',
      dot: '',
    },
    {
      head: 'Biểu diễn 3D theo thời gian thực',
      subHead: '',
      desc: 'Thông qua mô hình hóa 3D, ORBRO trực quan hóa các chuyển động động của người và phương tiện, qua đó cung cấp dữ liệu cần thiết cho quy hoạch đô thị, quản lý giao thông, tăng cường an toàn, v.v.',
      dot: '',
    },
    {
      head: 'Chỉ định khu vực (Zone)',
      subHead: '',
      desc: 'ORBRO thiết lập các khu vực (zone) cho các vùng cụ thể để quản lý và phân tích hiệu quả sự di chuyển của người và phương tiện trong phạm vi đó. Điều này hữu ích cho an toàn công cộng, quản lý sự kiện và điều tiết giao thông.',
      dot: '',
    },
    {
      head: 'Bảng điều khiển hiệu quả',
      subHead: '',
      desc: 'ORBRO tổng hợp dữ liệu về chuyển động của người và phương tiện để cung cấp các bảng điều khiển chứa thông tin chuyên sâu cần thiết cho quản lý giao thông, quy hoạch đô thị, an toàn công cộng, v.v. Điều này hỗ trợ những người ra quyết định thực hiện vận hành và quản lý đô thị một cách hiệu quả hơn.',
      dot: '',
    },
    {
      head: 'Tích hợp thành phố thông minh',
      subHead: '',
      desc: 'ORBRO tích hợp dữ liệu vị trí và các phân tích vào hệ thống thành phố thông minh nhằm nâng cao khả năng tự động hóa và hiệu quả vận hành đô thị. Điều này góp phần tối ưu hóa việc quản lý năng lượng, hệ thống giao thông và các dịch vụ công cộng.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/vi/enterprise/logistics/asset',
      },
    ],
  },
};
